import { StorageService } from '@services/storage.service';
import { Subscription } from 'rxjs';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { AuthService } from '@services/auth.service';
import { CommonService } from '@services/common.service';
import { NavController, NavParams, PopoverController, AlertController, ModalController } from '@ionic/angular';
import { SelectProjectModalComponent } from '@modals/select-project/select-project.component';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SessionService } from '@services/session.service';
import { EnumAppMenu } from '@models/AppMenus';
import { EnumUserRoles } from '@models/User';
import { environment } from '@environments/environment';


@Component({
    selector: 'header-page',
    templateUrl: './header-page.component.html',
    styleUrls: ['./header-page.component.scss'],
})
export class HeaderPageComponent implements OnInit {
    /**
     * Enabled component of season|edition
     */
    @Input('isEnabled') IsEnabled: boolean;

    @Input('backPath') BackPath: string;

    @Input('onGoBack') onGoBack: Function = null;

    /**
     *  Returns selected season id to allow reload pages with the correct season|edition
     */
    @Output() callback?: EventEmitter<any> = new EventEmitter<any>();

    // public Logo: String = "assets/project/project_logo.svg";

    public User: any;

    private sub: Subscription;

    public Entity: { Id: string, Name: string } = null;

    private EntityList: any[] = [];

    private entitiesLoaded = false;

    get CanChangeEntity(): boolean {
        const authorDomain = new URL(environment.Author.Website).hostname;
        const host = window.location.hostname.toLowerCase();
        const isAuthorDomain = host === 'localhost' || host.includes(authorDomain);
        return this.User?.IdRole === EnumUserRoles.ADMIN && isAuthorDomain && this.EntityList.length > 1;
    }

    constructor(private NavController: NavController,
        private PopoverController: PopoverController,
        private AlertController: AlertController,
        private ModalController: ModalController,
        private AuthService: AuthService,
        private SessionService: SessionService,
        private CommonService: CommonService) { }

    ngOnInit() {

        this.IsEnabled = this.IsEnabled ?? true;
        
        this.sub = this.SessionService.Session.subscribe(session => {
            this.User = session?.UserData;
            this.Entity = session?.Entity || null;

            if (this.User?.IdRole === EnumUserRoles.ADMIN && !this.entitiesLoaded) {
                this.entitiesLoaded = true;
                this.CommonService.GetEntityList().then(response => {
                    this.EntityList = response?.Result || [];
                });
            }
        })

    }

    ngOnDestroy(): void {
        if (this.sub)
            this.sub.unsubscribe();
    }

    OnChangeEdition(edition: any) {

        if (this.callback)
            this.callback.emit(edition);
    }

    public OnNavigateNotifications(ev?: any) {
        this.NavController.navigateForward('notifications');
    }

    public OnGoBack() {
        if (this.onGoBack)
            this.onGoBack();
    }

    private OnGoPage(path: string) {
        this.NavController.navigateForward(path);
    }


    private async OnLogout() {
        
        await this.AuthService.Logout();

        this.NavController.navigateRoot(EnumAppMenu.Login)
            .then(() => {
                window.location?.reload();
            });
    }

    async OnShowDefinitions(ev: any) {
        const popover = await this.PopoverController.create({
            component: PopoverHeaderComponent,
            componentProps: {
                onAccount: () => this.OnGoPage('account'),
                onSettings: () => this.OnGoPage('settings'),
                onSupport: () => this.OnGoPage('support'),
                onLogout: () => this.OnLogout(),
                onChangeEntity: () => this.OnChangeEntity(),
                showChangeEntity: this.CanChangeEntity
            },
            // cssClass: 'my-custom-class',
            event: ev,
            translucent: true
        });
        await popover.present();

        const { role } = await popover.onDidDismiss();
        // console.log('onDidDismiss resolved with role', role);
    }

    async OnChangeEntity() {
        const entities = this.EntityList;

        if (!entities?.length) return;

        const currentEntityId = this.Entity?.Id;

        const modal = await this.ModalController.create({
            component: SelectProjectModalComponent,
            componentProps: {
                entities: entities.map(it => ({ Id: it?.Id, Name: it?.Name })),
                currentEntityId,
                confirmText: 'Trocar'
            },
            backdropDismiss: false,
            cssClass: 'default small'
        });

        await modal.present();

        const { data, role } = await modal.onDidDismiss();

        if (role === EnumGenericRoleActionAlerts.Confirm && data) {
            await this.AuthService.SetEntity({ Id: data?.Id, Name: data?.Name });

            this.NavController.navigateRoot(EnumAppMenu.Dashboard)
                .then(() => {
                    window.location?.reload();
                });
        }
    }
}


@Component({
    selector: 'popover-menu',
    template: `
		<ion-content class="ion-padding">
			<ion-item button lines="none" detail="false" class="ion-no-margin" (click)="OnGoAccount($event)">
				<ion-icon iconMode slot="start" name="person-circle-outline"></ion-icon>
				<ion-label>A minha conta</ion-label>
			</ion-item>
			<ion-item hidden button lines="none" detail="false" class="ion-no-margin" (click)="OnGoSettings($event)">
				<ion-icon iconMode slot="start" name="settings-outline"></ion-icon>
				<ion-label>Definições</ion-label>
			</ion-item>
            <ion-item button lines="none" detail="false" class="ion-no-margin" (click)="OnGoSupport($event)">
				<ion-icon iconMode slot="start" name="information-circle-outline"></ion-icon>
				<ion-label>Área de apoio</ion-label>
			</ion-item>
			<ion-item *ngIf="ShowChangeEntity" button lines="none" detail="false" class="ion-no-margin" (click)="OnGoChangeEntity($event)">
				<ion-icon iconMode slot="start" name="swap-horizontal-outline"></ion-icon>
				<ion-label>Alterar entidade</ion-label>
			</ion-item>
			<ion-item button lines="none" detail="false" class="ion-no-margin" (click)="OnGoLogout($event)">
				<ion-icon iconMode slot="start" name="log-out-outline"></ion-icon>
				<ion-label>Terminar sessão</ion-label>
			</ion-item>
		</ion-content>
	`
})
export class PopoverHeaderComponent implements OnInit {

    private onGoAccount: Function;
    private onGoSettings: Function;
    private onGoSupport: Function;
    private onGoLogout: Function;
    private onChangeEntity: Function;
    public ShowChangeEntity: boolean;

    constructor(private NavParams: NavParams, private PopoverController: PopoverController, private AlertController: AlertController) {

        this.onGoAccount = this.NavParams.get('onAccount');
        this.onGoSettings = this.NavParams.get('onSettings');
        this.onGoSupport = this.NavParams.get('onSupport');
        this.onGoLogout = this.NavParams.get('onLogout');
        this.onChangeEntity = this.NavParams.get('onChangeEntity');
        this.ShowChangeEntity = this.NavParams.get('showChangeEntity') ?? false;
    }

    ngOnInit(): void {

    }

    OnGoAccount(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (this.onGoAccount) this.onGoAccount();
        this.PopoverController.dismiss();
    }

    OnGoSettings(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (this.onGoSettings) this.onGoSettings();
        this.PopoverController.dismiss();
    }

    OnGoSupport(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        if (this.onGoSupport) this.onGoSupport();
        this.PopoverController.dismiss();
    }

    OnGoChangeEntity(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        this.PopoverController.dismiss();
        if (this.onChangeEntity) this.onChangeEntity();
    }

    async OnGoLogout(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();


        const role = await this.showAlert();

        if (role == 'cancel') return;

        if (this.onGoLogout) this.onGoLogout();

        this.PopoverController.dismiss();
    }

    /**
     * 
     * @returns role
     */
    private async showAlert() {

        const alert = await this.AlertController.create({
            cssClass: 'default',
            header: 'Aviso',
            subHeader: '',
            message: 'Pretende terminar a sua sessão?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'cancelar',
                    role: EnumGenericRoleActionAlerts.Cancel
                },
                {
                    text: 'Continuar',
                    role: EnumGenericRoleActionAlerts.Confirm
                }
            ]
        });

        await alert.present();

        const { role } = await alert.onDidDismiss();

        return role;

    }

}
